import { useApp } from 'contexts/app';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Paper,
    ResponsiveDialog,
    Stack,
    styled,
    Text,
} from 'shell/components';

const ViewGradingSettingsDialog = ({ open, onClose }) => {
    const { currentAssignment } = useApp();

    const handleClose = () => {
        onClose();
    };

    return (
        <CustomResponsiveDialog open={open} scroll={'paper'} onClose={handleClose}>
            <DialogTitle>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'medium'}>
                        Advanced Grading Settings
                    </Text>
                    <IconButton
                        aria-label={'close'}
                        kind={'exit'}
                        size={'medium'}
                        variant={'square'}
                        onClick={handleClose}
                    />
                </Stack>
            </DialogTitle>
            <Divider />
            <CustomDialogContent>
                <Stack spacing={2}>
                    <Text variant={'p1'} weight={'medium'}>
                        Additional Grading Instructions for the AI
                    </Text>
                    <CustomPaper variant={'outlined'}>
                        <Stack spacing={5}>
                            <Text>
                                In this section, you can give the AI extra guidance for its grading suggestions. These
                                instructions can be general or tailored to each specific criterion.
                            </Text>
                            <Stack spacing={2}>
                                <Text>General Instructions</Text>
                                <Text color={'light'} rich>
                                    {currentAssignment.ai_grading_context || 'None'}
                                </Text>
                            </Stack>
                            <Stack spacing={2}>
                                <Text>Criterion-Specific Instructions</Text>
                                <Stack spacing={4}>
                                    {currentAssignment.rubric?.criteria?.map((criterion) => (
                                        <CriterionPaper key={criterion.id} variant={'outlined'}>
                                            <Stack spacing={4}>
                                                <Stack spacing={2}>
                                                    <Text>{criterion.title}</Text>
                                                    <Text color={'light'}>{criterion.description}</Text>
                                                </Stack>
                                                <Stack spacing={2}>
                                                    <Text>Grading Instructions</Text>
                                                    <Text color={'light'} rich>
                                                        {currentAssignment.ai_grading_settings?.criteria?.[criterion.id]
                                                            ?.grading_instructions || 'None'}
                                                    </Text>
                                                </Stack>
                                            </Stack>
                                        </CriterionPaper>
                                    ))}
                                </Stack>
                            </Stack>
                        </Stack>
                    </CustomPaper>
                </Stack>
            </CustomDialogContent>
            <Divider />
            <DialogActions>
                <Stack direction={'row'} spacing={4}>
                    <Button aria-hidden={false} color={'neutral'} variant={'tertiary'} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button onClick={handleClose}>Close</Button>
                </Stack>
            </DialogActions>
        </CustomResponsiveDialog>
    );
};

const CustomResponsiveDialog = styled(ResponsiveDialog)(() => {
    return {
        '& .MuiPaper-root > .MuiBox-root': {
            padding: 0,
        },
        '& .MuiDialog-paper': {
            maxWidth: '960px',
            width: '100%',
            height: '100%',
        },
    };
});

const CustomDialogContent = styled(DialogContent)(({ theme }) => {
    return {
        background: theme.palette.ensightful.neutral[50],
    };
});

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        maxWidth: '700px',
        padding: theme.spacing(5),
    };
});

const CriterionPaper = styled(Paper)(({ theme }) => {
    return {
        background: theme.palette.ensightful.neutral[50],
    };
});

export default ViewGradingSettingsDialog;
